import type { HelpFile } from '../../types/help'
import { IdentitySnapshotViewTestIds } from '../../../testids/IdentitySnapshotViewTestIds'

export const identitySnapshotViewHelp: HelpFile = {
  docPage: '/docs/identity/identities',
  texts: {
    [IdentitySnapshotViewTestIds.colAttributeName]: null,
    [IdentitySnapshotViewTestIds.colAttributeObserved]: 'Timestamp when this attribute value was last observed from a source system.',
    [IdentitySnapshotViewTestIds.colAttributeType]: null,
    [IdentitySnapshotViewTestIds.colAttributeValue]: null,
    [IdentitySnapshotViewTestIds.colIdentifierPrimary]: 'Whether this identifier is the primary identifier for the identity.',
    [IdentitySnapshotViewTestIds.colIdentifierType]: 'Type of identifier, e.g. email, employee ID, or UPN.',
    [IdentitySnapshotViewTestIds.colIdentifierValidFrom]: null,
    [IdentitySnapshotViewTestIds.colIdentifierValue]: 'Value of the identifier as known by the source system.',
  },
}
